import {Inject, Injectable} from '@angular/core'
import {Observable} from 'rxjs'
import {CFT_I18N_TRANSLATION_PROVIDER, DefaultI18nProvider, Labels, TranslationProvider} from './i18n.types'

@Injectable({providedIn: 'root'})
export class I18nService {
  constructor(
    @Inject(CFT_I18N_TRANSLATION_PROVIDER)
    private readonly provider: TranslationProvider = new DefaultI18nProvider(),
  ) {}

  load(lang: string): Observable<Labels> {
    return this.provider.load(lang)
  }

  translate$(key: string, params?: Record<string, string>): Observable<string> {
    return this.provider.selectTranslate(key, params)
  }

  /**
   * Only use this method if you are sure that the translations are fully loaded.
   */
  translate(key: string, params?: Record<string, string | number>): string {
    return this.provider.translate(key, params)
  }

  translateObject<T = unknown>(key: string, params?: Record<string, string | number>): T {
    return this.provider.translateObject(key, params)
  }

  getActiveLang(): string {
    return this.provider.getActiveLang()
  }
}
